






























import Vue from 'vue'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'
export default Vue.extend({
  name: 'Permissions',
  props: {
    restaurantId: String,
    accessCode: String,
  },
  data: () => ({
    permissionDenied: false,
    restaurant: null as RestaurantPublic | null,
  }),
  async created() {
    this.restaurant = await restaurants.getPublicRestaurant(this.restaurantId)
  },
  mounted() {
    if (!this.restaurantId || !this.accessCode) {
      // Not supposed to happen, go back.
      this.$router.push({ name: 'home' })
      return
    }
    this.askPermission()
  },
  methods: {
    askPermission: async function() {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
        // User has given video and audio permission, continue to room
        this.$router.push({
          name: 'seating',
          params: { restaurantId: this.restaurantId, accessCode: this.accessCode },
        })
      } catch (err) {
        this.permissionDenied = true
        setTimeout(this.askPermission, 500)
      }
    },
    goBack: function() {
      // Go back to the SubmitAccessCode screen with the accessCode prefilled.
      this.$router.push({
        name: 'submitAccessCode',
        params: { restaurantId: this.restaurantId },
      })
    },
  },
})
